import React, {useEffect, useState, useRef} from "react";
import queryString from 'query-string';
import dayjs from 'dayjs';
import {DescriptionText, FlexContainer, H1Text, H2Text, Spinner} from "../../design";
import {Col, Row} from "react-awesome-styled-grid";
import TransactionModal from "../../components/modal/transaction";
import SuccessModal from "../../components/modal/success";
import {
    addInventoryOrderChargeById,
    API,
    BASE_URLS,
    declinePaymentLinkByGid,
    getCheckoutCardCharges,
    getCheckoutReconnection,
    getInventoryOrderById,
    getQrPaymentReconnection,
    getSecretValuesById,
    getServerEncription,
    generateClientKeyPair,
    encryptData,
    inventoryOrderSplitUp,
    getPayPalClientToken,
    getMrn,
    action,
    getWalletOrderInfo,
    confirmWalletOrderInfo,
} from "../../api";
import {
    MESSAGES,
    NETBANKING_LIST,
    QR_STATUSES,
    REFRENCE_ID_LENGTH,
    SESSION_TIME,
    SWIREPAY_URL,
    TabNames,
    TANGEDCO_PG,
    WOOCOMMERCE_ORDER_STATUSES,
    ACQUIRER_TYPE_PAYPAL,
    ACQUIRER_TYPE_PAYPAL_BNY,
} from "../../appconstants";
import {AmountDivideByHundred} from "../../helper";
import BaseSplitPage from "../../components/splitpage";
import Header from "./smallscreen/header";
import currencyFormatter from "../../utils/currencyformatter";
import CardPayment from "../../components/cardpayment/CardPayment";
import Support from "../../components/support";
import SmallScreenFooter from "../../components/footer";
import getMenuTabs from "../../utils/getMenuTabs";
import getUniquePaymentTypes from "../../utils/getUniquePaymentTypes";
import getUniquePaymentTypesV2 from "../../utils/getUniquePaymentTypesV2";
import UpiPayment from "../../components/UpiCheckout/UpiCheckout";
import AchPayment from "../../components/achPaymentWithPlaid";
import InstantPayment from "../../components/instantpayment/InstantPayment";
import BankPayment from "../../components/bankpayment/BankPayment";
import NetBanking from "../../components/netbanking/NetBanking";
import GooglePay from "../../components/googlePay/GooglePay";
import PayPalGooglePay from "../../components/payPalGooglePay";
import PaymentMethodTabs from "../../components/paymentmethodtabs";
import AlertModal from "../../components/modal/alert";
import WARNING_ICON from "../../assets/imgs/exclamation_warning.svg"
import SUCCESS_ICON from "../../assets/imgs/success.svg";
import EPaymentImg from "../../assets/imgs/e payments.svg";
import OMEGAITRlogo from "../../assets/imgs/OmegaITRlogo.png";
import ApplePay from "../../components/applePay/ApplePay";
import RecaptchaModal from "../../components/recaptcha";
import Apple from '../../routes/apple';
import ApplePayButton from '../apple/PayPalApplePay';
import PayPalCheckout from "../paypalCheckout";
import SavedPaymentMethods from "../../components/SavedPaymentMethods";
import { useDispatch, useSelector } from "react-redux";
import { setUpdateStatus } from "../../redux/customerDetailsInfo";
import PaymentExpandableRowsV2 from "../../components/PaymentExpandableRowsV2";
import { setFormData } from "../../redux/appConfigInfo";
import { getCountryCodeAndNumber } from "../../utils/getCountryCodeAndNumber";
import PaymentExpandableRows from "../../components/paymentExpandableRows";
import TipInput from "../../components/TipInput";
import { Base64 } from "js-base64";
import { message } from "antd";
import { formatToE164 } from "../../utils/formatToE164";

type Props = {
    history: {
        push: Function,
    },
}

const InventoryOrder = (props: Props) => {

    const {match: {params: {inventoryorderId}}, location: {pathname, search}} = props;
    const [isTransactionModalOpen, setTransactionModalOpen] = useState(false);
    const [isTransactionSuccessModalOpen, setTransactionSuccessModalOpen] = useState(false);
    const [payment, setPayment] = useState(null);
    const [errorMessage, setErrorMessage] = useState();
    const [isShowSpinner, setShowSpinner] = useState(false);
    const [submitBtnText, setSubmitBtnText] = useState(null);
    const [supportedPaymentTypes, setSupportedPaymentTypes] = useState(null);
    const [paymentTypeOrder, setPaymentTypeOrder] = useState(null);
    const [selectedTab, setSelectedTab] = useState(parseInt(localStorage.getItem(`${inventoryorderId}-tap-index`) || 0));
    const [tabName, setTabName] = useState('');
    const [convenience, setConvenience] = useState(0);
    const [gst, setGst] = useState(0);
    const [totalAmount, setTotalAmount] = useState(null);
    const [tipInputValue, setTipInputValue] = useState('');
    const [customTip, setCustomTip] = useState(false);
    const [selectedTipGid, setSelectedTipGid] = useState(null);
    const [tipAmount, setTipAmount] = useState(0);
    const tipAmountRef = useRef(0);
    useEffect(() => {
        tipAmountRef.current = tipAmount;
    }, [tipAmount]);
    const [isTipApplied, setIsTipApplied] = useState(false);
    const [isSplitUpLoading, setIsSplitUpLoading] = useState(false);
    const [orderBreakdown, setOrderBreakdown] = useState({
        subTotal: 0,
        totalTax: 0,
        totalServiceFee: 0,
        deliveryFee: 0,
        orderDiscountAmount: 0,
        total: 0,
    });
    const [userType, setUserType] = useState('');
    const [banksList, setBanksList] = useState(null);
    const [isTest, setIsTest] = useState(null);
    const [bankTypes, supportedBankTypes] = useState([null]);
    const [bankImageUrl, setBankImageUrl] = useState(null);
    const [partnerImageUrl, setPartnerImageUrl] = useState(null);
    const [supportPhoneNumber, setSupportPhoneNumber] = useState(null);
    const [upiError, setUpiError] = useState('');
    const [gpaySecretValues, setGpaySecretValues] = useState(null);
    const [gpayError, setGpayError] = useState(null);
    const [applePayment, setApplePayment] = useState(false);
    const [ipAddress, setIpAddress] = useState('');
    const [upiDownTime, setUpiDownTime] = useState(false);
    const [shippingAddress, setShippingAddress] = useState(null)
    const [isApplePay, setIsApplePay] = useState(false);
    const [swirepayUS, setSwirepayUS] = useState(false);
    const [googlePayUs, setGooglePayUs] = useState(false);
    const [recaptchaModalVisible, setRecaptchaModalVisible] = useState(false);
    const [savedPaymentDetails, setSavedPaymentDetails] = useState(null);
    const [recaptchaPaymentType, setRecaptchaPaymentType] = useState(null);
    const [cardPointGooglePayToken, setCardPointGooglePayToken] = useState(null);
    const [googlePayBreakdownInfo, setGooglePayBreakdownInfo] = useState(null);
    const [paymentLinkGlobalRecaptcha, setPaymentLinkGlobalRecaptcha] = useState(null);
    const [payPalClientAuth, setPayPalClientAuth] = useState('');
    const [payPalClientId, setPaypalClientId] = useState('');
    const [paypalApplePayMessageModal, setPaypalApplePayMessageModal] = useState(false);
    const [paypalApplePayRecaptcha, setPaypalApplePayRecaptcha] = useState(null);
    const [orderDatas, setOrderData] = useState(null);
    const isPayPalApple = useRef(false);
    const isPayPalGoogle = useRef(false);
    const paypalPaymentData = useRef(null);
    const commonRecaptchaToken = useRef(null);
    const PayPalCheckoutEnable = useRef(false);
    const orderDatasRef = useRef(null);
    const accountGid = [
      'account-cdfe7eecff324778a88a2727177a1c8f'
    ];
    const [plaidPublicToken, setPlaidPublicToken] = useState(() => localStorage.getItem(`plaidPublicToken-${inventoryorderId}`) || undefined);
    const updateCustomerRedux = useSelector((state) => state.customerDetailsInfo);
    const dispatch = useDispatch();

    const defaultAlertConfig = {
        showIcon: false, isOpen: false, hideBtn: true,
        cancel: null, header: null, body: null,
        submitBtnText: null, cancelBtnText: null, showCancelBtn: false,
        showSubmitBtn: false, submit: null, icon: null
    };

    const [alertConfig, setAlertConfig] = useState(defaultAlertConfig);

    useState(() => {
        if (window.ApplePaySession) {
          setIsApplePay(true);
        }
      }, []);

    useEffect(() => {
        const parsed = queryString.parse(search);
        const shopTable = parsed.tableGid;
        const slug = parsed.slugName;
        if (search && !shopTable && !slug) {
            getInventoryDataWithSearchValue();
        } else {
            getInventoryDataWithoutSearchValue();
        }
        if (shopTable && slug) {
            localStorage.setItem('shopTable', shopTable);
            localStorage.setItem('slugName', slug);
        }
    }, [inventoryorderId, search]);

    const getData = async () => {
        const response = await fetch('https://api.ipify.org/?format=json');
        const data = await response.json();
        setIpAddress(data.ip);
    }

    useEffect(() => {
        getData();
    }, []);

    useEffect(() => {
      if(updateCustomerRedux?.updateStatus && updateCustomerRedux?.customerDetails){
          if (updateCustomerRedux?.customerDetails?.name  && updateCustomerRedux?.customerDetails?.name !== '') {
              setPayment((prev) => ({...prev, customer: { ...prev.customer, name: updateCustomerRedux.customerDetails.name } }));
          };
          if (updateCustomerRedux?.customerDetails?.email  && updateCustomerRedux?.customerDetails?.email !== '') {
              setPayment((prev) => ({...prev, customer: { ...prev.customer, email: updateCustomerRedux.customerDetails.email } }));
          };
          if (updateCustomerRedux?.customerDetails?.phoneNumber && updateCustomerRedux?.customerDetails?.phoneNumber !== 'undefined'
              && updateCustomerRedux?.customerDetails?.phoneNumber !== '+1'
          ) {
              setPayment((prev) => ({...prev, customer: { ...prev.customer, phoneNumber: updateCustomerRedux.customerDetails.phoneNumber } }));
          };
          dispatch(setUpdateStatus(false));
      };
    }, [updateCustomerRedux]);

    useEffect(() => {
        if (payment && payment.account && payment.account.currency && payment.inventoryOrder) {
            const currentTotal = orderBreakdown.total || (payment.inventoryOrder.netPayable !== undefined ? payment.inventoryOrder.netPayable : payment.inventoryOrder.total) || 0;
            setSubmitBtnText(`PAY ${currencyFormatter(AmountDivideByHundred(currentTotal), payment.account.currency.name)}`);
            setTotalAmount(currencyFormatter(AmountDivideByHundred(currentTotal), payment.account.currency.name));
        }
        const hasApplePay = payment && payment.account && payment.account.supportedPaymentTypes && payment.account.supportedPaymentTypes.includes('APPLE_PAY_US');
        const hasSwirepay = payment && payment.account && payment.account.supportedPaymentTypes && payment.account.supportedPaymentTypes.includes('SWIREPAY_US');
        const hasGooglePay = payment && payment.account && payment.account.supportedPaymentTypes && payment.account.supportedPaymentTypes.includes('GOOGLE_PAY_US');
        setApplePayment(hasApplePay);
        setSwirepayUS(hasSwirepay);
        setGooglePayUs(hasGooglePay);

        const acquirer = payment?.account?.acquirer || payment?.account?.aggregatorName;
        const hasPayPal = acquirer === ACQUIRER_TYPE_PAYPAL || acquirer === ACQUIRER_TYPE_PAYPAL_BNY || payment?.account?.supportedPaymentTypes?.includes('PAYPAL_WALLET') || payment?.account?.supportedPaymentTypes?.includes('VENMO');
        PayPalCheckoutEnable.current = hasPayPal;

        if (payment && payment.account && payment.account.gid) {
            if (hasPayPal) {
                getPayPalAccountInfo(payment?.account?.gid);
            }
            if (hasGooglePay || hasApplePay) {
                getGooglePayMerchantValues(payment.account.gid, payment.account?.portal?.test);
            }
            if (TANGEDCO_PG === payment.account.gid) {
                if (payment.account.paymentTypeOrder) {
                    setPaymentTypeOrder([{ category: 'CARD' }]);
                } else setSupportedPaymentTypes(['CARD']);
                setUpiError('UPI/QR is temporarily down');
            } else if (TANGEDCO_PG !== payment.account.gid) {
                if (payment.account.paymentTypeOrder) {
                    const rawTypes = payment?.paymentMethodType?.length > 0 ? payment?.paymentMethodType : payment?.account?.supportedPaymentTypes;
                    const paymentMethod = getUniquePaymentTypesV2(rawTypes) || [];
                    const paymentOrders = payment && payment?.account && payment?.account?.paymentTypeOrder;
                    const hasWalletEnabled = paymentMethod.includes('WALLET') || hasGooglePay || hasApplePay || hasPayPal || hasSwirepay;
                    let filterPaymentOrder = paymentOrders.filter((order) => paymentMethod.includes(order.category));
                    // Ensure the WALLET tab is included when any wallet method is enabled on the account
                    if (hasWalletEnabled && !filterPaymentOrder.find(o => o.category === 'WALLET')) {
                        const walletOrder = paymentOrders.find(o => o.category === 'WALLET');
                        if (walletOrder) filterPaymentOrder = [...filterPaymentOrder, walletOrder];
                    }
                    if (payment.account && hasWalletEnabled) {
                        setPaymentTypeOrder(filterPaymentOrder);
                    } else {
                        const newfilterPaymentOrder = filterPaymentOrder.filter(info => info.category !== 'WALLET');
                        setPaymentTypeOrder(newfilterPaymentOrder);
                    }
                } else {
                    setSupportedPaymentTypes(payment?.paymentMethodType?.length > 0 ? payment?.paymentMethodType : payment?.account?.supportedPaymentTypes);
                }
            }
        }
        setSupportPhoneNumber(payment && payment.support && payment.support.phone);

        // Pre-fetch Google Pay breakdown for inventory order
        const gpayGid = payment?.inventoryOrder?.gid || inventoryorderId;
        if (gpayGid && (hasGooglePay || hasApplePay)) {
            (async () => {
                try {
                    const { data: { entity } } = await API.post(`transaction-fee/split-up`, {
                        spObjectType: "INVENTORY_ORDER",
                        spObjectGid: gpayGid,
                        paymentType: "WALLET",
                        subType: "GOOGLE_PAY_US",
                        binType: "CREDIT"
                    });
                    if (entity) setGooglePayBreakdownInfo(entity);
                } catch (e) {
                    // Fallback: build minimal breakdown from payment data
                    const total = payment?.inventoryOrder?.netPayable !== undefined ? payment?.inventoryOrder?.netPayable : (payment?.inventoryOrder?.total || 0);
                    setGooglePayBreakdownInfo({ amount: total, totalPayable: total });
                }
            })();
        }
    }, [payment]);

    useEffect(() => {
        setErrorMessage(null);
        if (payment && payment.account && payment.account.currency && payment.inventoryOrder) {
            const currentTotal = orderBreakdown.total || (payment.inventoryOrder.netPayable !== undefined ? payment.inventoryOrder.netPayable : payment.inventoryOrder.total) || 0;
            setSubmitBtnText(`PAY ${currencyFormatter(AmountDivideByHundred(currentTotal), payment.account.currency.name)}`);
            setTotalAmount(currencyFormatter(AmountDivideByHundred(currentTotal), payment.account.currency.name));
        }
        setConvenience(0);
        setGst(0);
    }, [selectedTab, orderBreakdown.total, payment]);

    const populateOrderData = (value) => {
        if (value && value.inventoryOrder) {
            const order = value.inventoryOrder;
            const existingTip = order.totalTip !== undefined ? order.totalTip : (order.tipAmount !== undefined ? order.tipAmount : (order.tip || 0));
            if (existingTip > 0) {
                setTipAmount(existingTip);
                tipAmountRef.current = existingTip;
                setTipInputValue((existingTip / 100).toFixed(2));
                setIsTipApplied(true);
            } else {
                setTipAmount(0);
                tipAmountRef.current = 0;
                setTipInputValue('');
                setIsTipApplied(false);
            }
            const orderTotal = order.netPayable !== undefined ? order.netPayable : (order.total !== undefined ? order.total : 0);
            const orderTax = order.tax !== undefined ? order.tax : (order.totalTax || 0);
            const orderFee = order.serviceFee !== undefined ? order.serviceFee : (order.totalServiceFee || 0);
            const orderDisc = (order.orderDiscount !== undefined || order.itemDiscount !== undefined)
                ? ((order.orderDiscount || 0) + (order.itemDiscount || 0))
                : (order.orderDiscountAmount || 0);
            setOrderBreakdown({
                subTotal: order.subTotal || 0,
                totalTax: orderTax,
                totalServiceFee: orderFee,
                deliveryFee: order.deliveryFee || 0,
                orderDiscountAmount: orderDisc,
                total: orderTotal,
            });
        }
    };

    const handleSplitUpCalculation = async (tipCents) => {
        if (!payment || !payment.inventoryOrder) return;
        setIsSplitUpLoading(true);

        const order = payment.inventoryOrder;
        const payload = {
            tip: tipCents,
        };

        try {
            const result = await inventoryOrderSplitUp(inventoryorderId, payload);
            if (result) {
                const resOrder = (result && result.inventoryOrder) ? result.inventoryOrder : (result?.entity ? result.entity : result);

                const newTotal = resOrder.netPayable !== undefined 
                    ? resOrder.netPayable 
                    : (resOrder.totalPayable !== undefined 
                        ? resOrder.totalPayable 
                        : (resOrder.total !== undefined 
                            ? resOrder.total 
                            : ((order.subTotal || 0) + (resOrder.tax !== undefined ? resOrder.tax : (resOrder.totalTax !== undefined ? resOrder.totalTax : (order.totalTax || 0))) + (resOrder.serviceFee !== undefined ? resOrder.serviceFee : (resOrder.totalServiceFee !== undefined ? resOrder.totalServiceFee : (order.totalServiceFee || 0))) + (resOrder.deliveryFee !== undefined ? resOrder.deliveryFee : (order.deliveryFee || 0)) + tipCents - (resOrder.orderDiscount !== undefined ? resOrder.orderDiscount : (resOrder.orderDiscountAmount !== undefined ? resOrder.orderDiscountAmount : (order.orderDiscountAmount || 0))))));

                const newTip = resOrder.tipAmount !== undefined 
                    ? resOrder.tipAmount 
                    : (resOrder.totalTip !== undefined 
                        ? resOrder.totalTip 
                        : (resOrder.tip !== undefined ? resOrder.tip : tipCents));

                const newSubTotal = resOrder.subTotal !== undefined 
                    ? resOrder.subTotal 
                    : (order.subTotal || 0);

                const newTax = resOrder.tax !== undefined 
                    ? resOrder.tax 
                    : (resOrder.totalTax !== undefined ? resOrder.totalTax : (order.totalTax || 0));

                const newServiceFee = resOrder.serviceFee !== undefined 
                    ? resOrder.serviceFee 
                    : (resOrder.totalServiceFee !== undefined ? resOrder.totalServiceFee : (order.totalServiceFee || 0));

                const newDeliveryFee = resOrder.deliveryFee !== undefined 
                    ? resOrder.deliveryFee 
                    : (order.deliveryFee || 0);

                const newDiscount = (resOrder.orderDiscount !== undefined || resOrder.itemDiscount !== undefined)
                    ? ((resOrder.orderDiscount || 0) + (resOrder.itemDiscount || 0))
                    : (resOrder.orderDiscountAmount !== undefined ? resOrder.orderDiscountAmount : (order.orderDiscountAmount || 0));

                setTipAmount(newTip);
                tipAmountRef.current = newTip;
                setIsTipApplied(newTip > 0);
                setOrderBreakdown({
                    subTotal: newSubTotal,
                    totalTax: newTax,
                    totalServiceFee: newServiceFee,
                    deliveryFee: newDeliveryFee,
                    orderDiscountAmount: newDiscount,
                    total: newTotal,
                });

                const formattedTotal = currencyFormatter(AmountDivideByHundred(newTotal), payment.account?.currency?.name);
                setTotalAmount(formattedTotal);
                setSubmitBtnText(`PAY ${formattedTotal}`);
            }
        } catch (err) {
            const baseWithoutOldTip = (order.netPayable !== undefined ? order.netPayable : (order.total || 0)) - (order.tipAmount !== undefined ? order.tipAmount : (order.totalTip !== undefined ? order.totalTip : (order.tip || 0)));
            const fallbackTotal = baseWithoutOldTip + tipCents;
            setTipAmount(tipCents);
            tipAmountRef.current = tipCents;
            setIsTipApplied(tipCents > 0);
            setOrderBreakdown(prev => ({
                ...prev,
                total: fallbackTotal,
            }));
            const formattedTotal = currencyFormatter(AmountDivideByHundred(fallbackTotal), payment.account?.currency?.name);
            setTotalAmount(formattedTotal);
            setSubmitBtnText(`PAY ${formattedTotal}`);
        } finally {
            setIsSplitUpLoading(false);
        }
    };

    const handleApplyTip = () => {
        const cents = tipInputValue ? Math.round(parseFloat(tipInputValue) * 100) : 0;
        tipAmountRef.current = cents;
        handleSplitUpCalculation(cents);
    };

    const handleClearTip = () => {
        setTipInputValue('');
        tipAmountRef.current = 0;
        handleSplitUpCalculation(0);
    };

    const getGooglePayMerchantValues = async (accountGid, isTest) => {
        try {
            const values = await getSecretValuesById(accountGid, isTest);
            setGpaySecretValues(values);
        } catch (error) {
            setGpayError('Missing merchant details. Please contact support')
        }
    };

    const getInventoryDataWithSearchValue = async () => {
        const params = new URLSearchParams(search);
        if (!(params.get('ps') || params.get('mp')) || !params.get('secret')) {
            props.history.push(`${pathname}/error`);
            return;
        }
        setShowSpinner(true);
        try {
            const value = await getInventoryOrderById(inventoryorderId, search);
            if (value) {
                const {returnUrl, status} = value;
                const timeOut = returnUrl ? SESSION_TIME.REDIRECT_URL : SESSION_TIME.NO_REDIRECT_URL;
                if (WOOCOMMERCE_ORDER_STATUSES.CREATED !== status) {
                    setTransactionSuccessModalOpen(true);
                    setTimeout(function () {
                        const redirectUrl = returnUrl ? returnUrl : SWIREPAY_URL;
                        window.location = redirectUrl;
                    }, 10000);
                }
            }
        } catch (reason) {
            try {
                const value = await getInventoryOrderById(inventoryorderId, null);
                if (value) {
                    setPayment(value);
                    populateOrderData(value);
                    setUserType(value.account && value.account.mdr);
                    if (value.account && value.account.portal) {
                        const portal = value.account.portal.test;
                        setIsTest(portal);
                        setBankImageUrl(value.account && value.account.bankImageUrl);
                        setPartnerImageUrl(value.account && value.account.partnerImageUrl);
                        supportedBankTypes(value.account.supportedPaymentTypes);
                        if (portal) {
                            const supportedBanks = NETBANKING_LIST.filter(data => (data.isTest === true));
                            setBanksList(supportedBanks);
                        } else {
                            const supportedBanks = NETBANKING_LIST.filter(data => (data.isTest === false));
                            setBanksList(supportedBanks);
                        }
                    }
                }
            } catch (e) {
                props.history.push(`${pathname}/error`);
            }
            error(reason);
        } finally {
            setShowSpinner(false);
        }
    };

    const error = reason => {
        setErrorMessage(null);
        if (!reason) return;
        const {data: {message, messageCode}, status} = reason;
        if (MESSAGES.PAYMENT_LINK.EXPIRED === message) {
            props.history.push(`${pathname}/expired`)
        } else {
            if (messageCode === 5102) {
                props.history.push(`${pathname}/error`);
                return;
            }
            setErrorMessage(message);
            if (status === 500) {
                setErrorMessage(MESSAGES.PAYMENT_LINK.ERROR);
            }
            resetAlertConfig();
            setTransactionModalOpen(false);
            const errorEl = document.getElementById("error");
            if (null !== errorEl) {
                errorEl.scrollIntoView();
            }
        }
    };

    const getPaymentCharges = async (cardNumber, payments) => {
        setPayment(payments);
        try {
            const value = await getCheckoutCardCharges(inventoryorderId, cardNumber);
            if (value) {
                setConvenience(currencyFormatter(AmountDivideByHundred(value.feeAmount)));
                setGst(currencyFormatter(AmountDivideByHundred(value.taxAmount)));
                setSubmitBtnText(`PAY ${currencyFormatter(AmountDivideByHundred(payment.inventoryOrder.total), payment.account.currency.name)}`)
                setTotalAmount(currencyFormatter(AmountDivideByHundred(payment.inventoryOrder.total), payment.account.currency.name));
            }
        } catch (e) {
            setConvenience(0);
            setGst(0);
            setTotalAmount(currencyFormatter(AmountDivideByHundred(payment.inventoryOrder.total), payment.account.currency.name));
        } finally {
            setShowSpinner(false)
        }
    }

    const getInventoryDataWithoutSearchValue = async () => {
        setShowSpinner(true);
        try {
            const value = await getInventoryOrderById(inventoryorderId, null);
            if (value) {
                const {redirectUri} = value;
                // if (WOOCOMMERCE_ORDER_STATUSES.CREATED !== value.inventoryOrder.status) {
                //     if(value && value.redirectUrl){
                //         window.location = value.redirectUrl;
                //     }else{
                //     props.history.push(`${pathname}/expired`);
                //     return;
                //     }
                // }
                // if (value.account.integratedMerchant && LPG_CUSTOMER.includes(atob(value.account.integratedMerchant))) {
                //     const val = await getHealthCheck();
                //     if (val && val.status !== 'ACTIVE') {
                //         setUpiDownTime(true);
                //         notification.open({
                //             message: '',
                //             description: <img src={UPIIMAGE} alt="" />,
                //           });
                //     }
                //   }
                setPayment(value);
                populateOrderData(value);
                dispatch(setFormData({ code: 'CUSTOMER_DETAIL',
                  value: {
                    phoneNumber: getCountryCodeAndNumber(value?.inventoryOrder?.customer?.phoneNumber)?.phoneNumber,
                    countryCode: getCountryCodeAndNumber(value?.inventoryOrder?.customer?.phoneNumber)?.countryCode || '+1',
                    name: value?.inventoryOrder?.customer?.name,
                    email: value?.inventoryOrder?.customer?.email,
                    disablePhone: !!value?.inventoryOrder?.customer?.phoneNumber,
                    disableEmail: !!value?.inventoryOrder?.customer?.email,
                    disableName: !!value?.inventoryOrder?.customer?.name,
                  } 
                }));
                setShippingAddress(
                    value &&
                    value.inventoryOrder &&
                    value.inventoryOrder.customer &&
                    value.inventoryOrder.customer.shippingAddress
                );
                if (value.account && value.account.portal) {
                    const portal = value.account.portal.test;
                    setIsTest(portal);
                    setBankImageUrl(value.account && value.account.bankImageUrl);
                    setPartnerImageUrl(value.account && value.account.partnerImageUrl);
                    supportedBankTypes(value.account.supportedPaymentTypes);
                    if (portal) {
                        const supportedBanks = NETBANKING_LIST.filter(data => (data.isTest === true));
                        setBanksList(supportedBanks);
                    } else {
                        const supportedBanks = NETBANKING_LIST.filter(data => (data.isTest === false));
                        setBanksList(supportedBanks);
                    }
                }
                
                console.log(value)
                if ((value && value.account && value.account.supportedPaymentTypes && value.account.supportedPaymentTypes).includes('GOOGLE_PAY_US')) {
                   
                    getGooglePayMerchantValues(value && value.account && value.account.gid, value?.account?.portal?.test);
                }
                if ((value && value.account && value.account.supportedPaymentTypes && value.account.supportedPaymentTypes).includes('APPLE_PAY_US') || (value && value.account && value.account.supportedPaymentTypes && !swirepayUS && value.account.supportedPaymentTypes).includes('WALLET')) {
                    getGooglePayMerchantValues(value && value.account && value.account.gid, value?.account?.portal?.test);
                }
                setUserType(value.account && value.account.mdr);
            }
        } catch (e) {
            console.log('ERROR : ', e)
            props.history.push(`${pathname}/error`);
        } finally {
            setShowSpinner(false)
        }
    };

    const getCustomerGidFromPayment = () => {
        return (payment && payment.customer && payment.customer.gid) || (payment && payment.inventoryOrder && payment.inventoryOrder.customer && payment.inventoryOrder.customer.gid);
    };

    const chargeByNetBanking = async (data) => {
        const {gid} = data;
        const paymentMethod = {
            type: "NET_BANKING",
            netbanking: {
                swirepayBankGid: gid,
            },
        };
        const currentTip = tipAmountRef.current ?? tipAmount ?? 0;
        await addCheckoutPageById({paymentMethod: paymentMethod, customerGid: getCustomerGidFromPayment(payment), tip: currentTip, tipAmount: currentTip});
    };


    const chargeByUpi = async (data) => {
        const {paymentMethod} = data;
        const currentTip = tipAmountRef.current ?? tipAmount ?? 0;
        await addCheckoutPageById({
            "paymentMethod": paymentMethod,
            tip: currentTip,
            tipAmount: currentTip
        });
    };

    const chargeByAch = async (data) => {
        const {customer, paymentMethod} = data;
        const currentTip = tipAmountRef.current ?? tipAmount ?? 0;
        await addCheckoutPageById({customer, paymentMethod, customerGid: getCustomerGidFromPayment(payment), tip: currentTip, tipAmount: currentTip});
    };

    const chargeByInstantPay = async (data) => {
        const {walletAlias} = data;
        const paymentMethod = {
            type: "INSTANT_PAYMENT",
            instantPayment: {
                alias: walletAlias,
                type: "ALIAS",
            },
        };
        const currentTip = tipAmountRef.current ?? tipAmount ?? 0;
        await addCheckoutPageById({paymentMethod: paymentMethod, customerGid: getCustomerGidFromPayment(payment), tip: currentTip, tipAmount: currentTip});
    };

    const chargeBySwirepayUS = async (data) => {
        const {walletAlias} = data;
        const paymentMethod = {
            type:"WALLET",
            subType: "SWIREPAY_US",
            swirepayUS: {
                alias: walletAlias,
                type: "ALIAS",
            },
        };
        const currentTip = tipAmountRef.current ?? tipAmount ?? 0;
        await addCheckoutPageById({paymentMethod: paymentMethod, customerGid: getCustomerGidFromPayment(payment), tip: currentTip, tipAmount: currentTip});
    };

    const chargeByCard = async (data) => {
        const {paymentMethod, customer, notify} = data;
        const userAgent = {
            acceptHeaders: "Accept: text/html, application/xhtml+xml, application/xml;q=0.9, image/webp, */*;q=0.8",
            ip: ipAddress,
            language: window.navigator.language,
            colorDepth: window.screen.colorDepth,
            screenHeight: window.screen.height,
            screenWidth: window.screen.width,
            timeZone: new Date().getTimezoneOffset(),
            browserUserAgent: window.navigator.userAgent
        };
        paymentMethod.userAgent = userAgent;
        if (customer.Address) {
            //alert(JSON.stringify(customer.Address))
            delete customer.Address;
        }
        /* if(shippingAddress){
             //alert("abc"+JSON.stringify(shippingAddress))
         delete shippingAddress.country;
         shippingAddress.countryCode = "US";
         customer.shippingAddress = shippingAddress ;}*/
        const currentTip = tipAmountRef.current ?? tipAmount ?? 0;
        await addCheckoutPageById({
            paymentMethod,
            customer,
            shouldWhatsAppNotify: notify,
            tip: currentTip,
            tipAmount: currentTip
        });
    };

  const chargeBySavedPaymentMethods = async (data) => {
    const customerGid = getCustomerGidFromPayment(payment);
    const userAgent = {
        acceptHeaders: "Accept: text/html, application/xhtml+xml, application/xml;q=0.9, image/webp, */*;q=0.8",
        ip: ipAddress,
        language: window.navigator.language,
        colorDepth: window.screen.colorDepth,
        screenHeight: window.screen.height,
        screenWidth: window.screen.width,
        timeZone: new Date().getTimezoneOffset(),
        browserUserAgent: window.navigator.userAgent
    };
    const currentTip = tipAmountRef.current ?? tipAmount ?? 0;
    await addCheckoutPageById({
        paymentMethod: { ...data, customerGid, userAgent },
        recaptchaToken: data.recaptchaToken,
        platformType: 'WEB',
        tip: currentTip,
        tipAmount: currentTip
    });
  };

    const chargeByBank = async (data) => {
        const {customer, fundingSourceId} = data;
        const paymentMethod = {
            type: "ACH",
            bank: {
                referenceId: fundingSourceId,
            },
        };
        const currentTip = tipAmountRef.current ?? tipAmount ?? 0;
        await addCheckoutPageById({
            customer,
            paymentMethod: paymentMethod,
            customerGid: getCustomerGidFromPayment(payment),
            tip: currentTip,
            tipAmount: currentTip
        });
    };

    const chargeByGooglePay = async (data) => {
        const paymentMethod = {
            type: "WALLET",
            subType: "GOOGLE_PAY_US",
            googlePayUS: {
                apiVersionMinor: data.apiVersionMinor,
                apiVersion: data.apiVersion,
                paymentMethodDescription: data.paymentMethodData.description,
                paymentMethodTokenizationDataType: data.paymentMethodData.tokenizationData.type,
                paymentMethodTokenizationDataToken: data.paymentMethodData.tokenizationData.token,
                paymentMethodType: data.paymentMethodData.type,
                paymentMethodInfo: data.paymentMethodData.info
            },
        };
        if (data?.paymentMethodData?.info?.cardFundingSource === 'CREDIT') {
            paymentMethod.googlePayUS.binType = 'CREDIT';
        }
        const formattedPhoneNumber = formatToE164(
            data?.paymentMethodData?.info?.billingAddress?.phoneNumber,
            data?.paymentMethodData?.info?.billingAddress?.countryCode,
            '+14485555555',
        );
        const customer = {
            name: data?.shippingAddress?.name ?? data?.paymentMethodData?.info?.billingAddress?.name ?? payment?.customer?.name ?? payment?.inventoryOrder?.customer?.name ?? 'anonymous user',
            email: data?.email ?? payment?.customer?.email ?? payment?.inventoryOrder?.customer?.email ?? 'anonymous@swirepay.com',
            phoneNumber: formattedPhoneNumber || payment?.customer?.phoneNumber || payment?.inventoryOrder?.customer?.phoneNumber || '+14485555555',
        };
        const userAgent = {
            acceptHeaders: "Accept: text/html, application/xhtml+xml, application/xml;q=0.9, image/webp, */*;q=0.8",
            ip: ipAddress,
            language: window.navigator.language,
            colorDepth: window.screen.colorDepth,
            screenHeight: window.screen.height,
            screenWidth: window.screen.width,
            timeZone: new Date().getTimezoneOffset(),
            browserUserAgent: window.navigator.userAgent
        };
        setRecaptchaPaymentType('cardPointGooglePay');
        const currentTip = tipAmountRef.current ?? tipAmount ?? 0;
        await addCheckoutPageById({
            paymentMethod,
            customer,
            userAgent,
            customerGid: getCustomerGidFromPayment(payment),
            tip: currentTip,
            tipAmount: currentTip
        }, cardPointGooglePayToken);
    };


    const getPayPalAccountInfo = async (id) => {
        try {
            const payPalInfo = await getPayPalClientToken(id);
            const value = Base64.decode(payPalInfo);
            const value_json = JSON.parse(value);
            setPaypalClientId(value_json?.clientId);
            setPayPalClientAuth(payPalInfo);
            return payPalInfo;
        } catch (error) {
            console.error(error);
        }
    };

    const chargeByPaypalGooglePay = async (data, localRecaptchaToken = null) => {
        try {
            paypalPaymentData.current = data;
            setTransactionModalOpen(true);
            setRecaptchaPaymentType('paypalGooglePay');
            const value = await getPayPalAccountInfo(payment?.account?.gid);
            if (value) {
                isPayPalGoogle.current = true;
                const paymentMethod = {
                    type: "WALLET",
                    subType: "GOOGLE_PAY_US",
                    googlePayUS: {
                        apiVersionMinor: data.apiVersionMinor,
                        apiVersion: data.apiVersion,
                        paymentMethodDescription: data.paymentMethodData.description,
                        paymentMethodTokenizationDataType: data.paymentMethodData.tokenizationData.type,
                        paymentMethodTokenizationDataToken: data.paymentMethodData.tokenizationData.token,
                        paymentMethodType: data.paymentMethodData.type,
                        paymentMethodInfo: data.paymentMethodData.info
                    },
                };
                if (data?.paymentMethodData?.info?.cardFundingSource === 'CREDIT') {
                    paymentMethod.googlePayUS.binType = 'CREDIT';
                }
                const formattedPhoneNumber = formatToE164(
                    data?.paymentMethodData?.info?.billingAddress?.phoneNumber,
                    data?.paymentMethodData?.info?.billingAddress?.countryCode,
                    '+14485555555',
                );
                const customer = {
                    name: data?.shippingAddress?.name ?? data?.paymentMethodData?.info?.billingAddress?.name ?? payment?.customer?.name ?? payment?.inventoryOrder?.customer?.name ?? 'anonymous user',
                    email: data?.email ?? payment?.customer?.email ?? payment?.inventoryOrder?.customer?.email ?? 'anonymous@swirepay.com',
                    phoneNumber: formattedPhoneNumber || payment?.customer?.phoneNumber || payment?.inventoryOrder?.customer?.phoneNumber || '+14485555555',
                };
                const currentTip = tipAmountRef.current ?? tipAmount ?? 0;
                const responseEntity = await addCheckoutPageById({
                    paymentMethod: paymentMethod,
                    customer: customer,
                    customerGid: getCustomerGidFromPayment(payment),
                    tip: currentTip,
                    tipAmount: currentTip
                }, localRecaptchaToken);
                isPayPalGoogle.current = false;
                const psGid = responseEntity?.paymentSessionGid || responseEntity?.paymentSession?.gid;
                const psSecret = responseEntity?.psClientSecret || responseEntity?.paymentSession?.psClientSecret;
                const orderId = await getMrn(psGid, psSecret);
                // Step 2: confirm PayPal order
                await window.paypal.Googlepay().confirmOrder({
                    orderId,
                    paymentMethodData: data?.paymentMethodData,
                });
                // Step 3: capture/perform final action
                await action(psGid, psSecret);
                await chargeByIdSuccessActions(responseEntity);
            }
        } catch (err) {
            console.error('Google Pay Failed', err);
            message.error('GooglePay Transaction Failed');
            chargeByIdFailActions();
        } finally {
            setTransactionModalOpen(false);
        }
    };

    const chargeByApple = async (paymentData, recaptchaToken = paypalApplePayRecaptcha) => {
        const {
            deviceData,
            customerName,
            customerEmail,
            customerPhone,
            countryCode,
            stateCode,
            street,
            postalCode,
            city,
            cardNetwork,
            cardType,
            cardLast4,
        } = paymentData;
        const billingAddress = {
            city: city,
            countryCode: countryCode,
            state: stateCode,
            street: street
        };
        setRecaptchaPaymentType('paypalApplePay');
        const paymentMethod = {
            applePayUS: {
                deviceData: deviceData,
                cardBrand: cardNetwork,
                cardFundingType: cardType,
                applePayDynamicLast4: cardLast4,
                cardLast4: cardLast4,
            },
            type: "WALLET",
            subType: "APPLE_PAY_US",
            postalCode: postalCode,
            paymentMethodBillingAddress: (city && street && stateCode) ? billingAddress : null,
        };
        let customer = {
            email: customerEmail || payment?.customer?.email || payment?.inventoryOrder?.customer?.email,
            name: customerName || payment?.customer?.name || payment?.inventoryOrder?.customer?.name,
            phoneNumber: customerPhone || payment?.customer?.phoneNumber || payment?.inventoryOrder?.customer?.phoneNumber,
        };
        const value = await getPayPalAccountInfo(payment?.account?.gid);
        if (value) {
            isPayPalApple.current = true;
        }
        if (paymentData?.token?.paymentMethod?.type === 'credit' || paymentData?.paymentMethod?.type === 'credit' || paymentData?.cardType === 'credit') {
            paymentMethod.applePayUS.binType = 'CREDIT';
        }
        const currentTip = tipAmountRef.current ?? tipAmount ?? 0;
        const responseEntity = await addCheckoutPageById({
            paymentMethod: paymentMethod,
            customerGid: getCustomerGidFromPayment(payment),
            customer: customer,
            tip: currentTip,
            tipAmount: currentTip
        }, recaptchaToken);
        isPayPalApple.current = false;
        if (responseEntity) {
            responseEntity.paymentSessionGid = responseEntity?.paymentSessionGid || responseEntity?.paymentSession?.gid;
            responseEntity.psClientSecret = responseEntity?.psClientSecret || responseEntity?.paymentSession?.psClientSecret;
        }
        return responseEntity;
    };

    const chargeByCardpointeApplePay = async (paymentData) => {
        const {
            deviceData,
            // amount,
            customerName,
            customerEmail,
            customerPhone,
            countryCode,
            stateCode,
            street,
            postalCode,
            city,
            cardNetwork,
            cardType,
            cardLast4,
        } = paymentData;
      
        const billingAddress = {
            city: city,
            countryCode: countryCode,
            state: stateCode,
            street: street
        };

        const paymentMethod = {
            applePayUS: {
                deviceData: deviceData,
                cardBrand: cardNetwork,
                cardFundingType: cardType,
                applePayDynamicLast4: cardLast4,
                cardLast4: cardLast4
            },
            type: "WALLET",
            subType: "APPLE_PAY_US",
            postalCode: postalCode,
            paymentMethodBillingAddress: (city && street && stateCode) ? billingAddress : null,
        }

        let customer = {
            email: customerEmail,
            name: customerName,
            phoneNumber: customerPhone,
        }

        const currentTip = tipAmountRef.current ?? tipAmount ?? 0;
        await addCheckoutPageById({
            paymentMethod: paymentMethod,
            customerGid: getCustomerGidFromPayment(payment),
            customer: customer,
            tip: currentTip,
            tipAmount: currentTip
        }, null);
    };

    const chargeByApplePay = async (stripePaymentMethod) => {
        // const meta = stripePaymentMethod;
        const paymentMethod = {
            applePayUS: {
                stripePaymentMethodId: stripePaymentMethod.id,
                cardBrand: stripePaymentMethod.card.brand,
                cardExpMonth: stripePaymentMethod.card.exp_month,
                cardExpYear: stripePaymentMethod.card.exp_year,
                cardFundingType: stripePaymentMethod.card.funding,
                applePayDynamicLast4: stripePaymentMethod.card.wallet.dynamic_last4,
                cardLast4: stripePaymentMethod.card.last4,
                billingAddress: {
                    street: stripePaymentMethod.billing_details.address.line1,
                    city: stripePaymentMethod.billing_details.address.city,
                    state: stripePaymentMethod.billing_details.address.state,
                    postalCode: stripePaymentMethod.billing_details.address.postal_code,
                    countryCode: stripePaymentMethod.billing_details.address.country
                },
                name: stripePaymentMethod.billing_details.name,
                email: stripePaymentMethod.billing_details.email,
                phone: stripePaymentMethod.billing_details.phone
            },
            customerGid: getCustomerGidFromPayment(payment),
            type: "WALLET",
            subType: "APPLE_PAY_US",
            rawData: {
                stripePaymentMethodId: stripePaymentMethod.id,
                cardBrand: stripePaymentMethod.card.brand,
                cardExpMonth: stripePaymentMethod.card.exp_month,
                cardExpYear: stripePaymentMethod.card.exp_year,
                cardFundingType: stripePaymentMethod.card.funding,
                applePayDynamicLast4: stripePaymentMethod.card.wallet.dynamic_last4,
                cardLast4: stripePaymentMethod.card.last4,
                billingAddress: {
                    street: stripePaymentMethod.billing_details.address.line1,
                    city: stripePaymentMethod.billing_details.address.city,
                    state: stripePaymentMethod.billing_details.address.state,
                    postalCode: stripePaymentMethod.billing_details.address.postal_code,
                    countryCode: stripePaymentMethod.billing_details.address.country
                },
                name: stripePaymentMethod.name,
                email: stripePaymentMethod.email,
                phone: stripePaymentMethod.phone
            }
        };
        const currentTip = tipAmountRef.current ?? tipAmount ?? 0;
        await addCheckoutPageById({
            paymentMethod: paymentMethod,
            customerGid: getCustomerGidFromPayment(payment),
            tip: currentTip,
            tipAmount: currentTip
        });
    };

    const onApprove = async (data) => {
        try {
            const activeOrder = orderDatasRef.current || orderDatas;
            const psGid = activeOrder?.paymentSessionGid || activeOrder?.paymentSession?.gid;
            const psSecret = activeOrder?.psClientSecret || activeOrder?.paymentSession?.psClientSecret;
            await confirmWalletOrderInfo(psGid, psSecret);
            setTransactionSuccessModalOpen(true);
            chargeByIdSuccessActions(activeOrder);
        } catch (err) {
            console.error(err);
            throw err;
        }
    };

    const createOrder = async (paypalData, actions) => {
        try {
            const values = await getServerEncription(commonRecaptchaToken?.current ?? null);
            if (values?.public_key) {
                const keys = generateClientKeyPair();
                if (keys?.privateKey) {
                    let data = {};
                    const userAgent = {
                        acceptHeaders: "Accept: text/html, application/xhtml+xml, application/xml;q=0.9, image/webp, */*;q=0.8",
                        ip: ipAddress,
                        language: window.navigator.language,
                        colorDepth: window.screen.colorDepth,
                        screenHeight: window.screen.height,
                        screenWidth: window.screen.width,
                        timeZone: new Date().getTimezoneOffset(),
                        browserUserAgent: window.navigator.userAgent
                    };
                    let customer = {
                        email: payment?.customer?.email || payment?.inventoryOrder?.customer?.email,
                        phoneNumber: payment?.customer?.phoneNumber || payment?.inventoryOrder?.customer?.phoneNumber,
                        name: payment?.customer?.name || payment?.inventoryOrder?.customer?.name,
                    };
                    if (paypalData?.paymentSource === 'paypal') {
                        data = {
                            customer,
                            userAgent: userAgent,
                            customerGid: getCustomerGidFromPayment(payment),
                            shouldWhatsAppNotify: false,
                            paymentMethod: {
                                payPalWallet: {
                                    rawData: {
                                        experience_context: {
                                            payment_method_preference: "IMMEDIATE_PAYMENT_REQUIRED",
                                            landing_page: "LOGIN",
                                            return_url: SWIREPAY_URL,
                                            cancel_url: SWIREPAY_URL,
                                        }
                                    }
                                },
                                type: "WALLET",
                                subType: "PAYPAL_WALLET"
                            }
                        };
                    } else if (paypalData?.paymentSource === 'venmo') {
                        data = {
                            customer,
                            userAgent: userAgent,
                            customerGid: getCustomerGidFromPayment(payment),
                            shouldWhatsAppNotify: false,
                            paymentMethod: {
                                venmo: {
                                    rawData: {
                                        experience_context: {
                                            payment_method_preference: "IMMEDIATE_PAYMENT_REQUIRED",
                                            landing_page: "LOGIN",
                                            return_url: SWIREPAY_URL,
                                            cancel_url: SWIREPAY_URL,
                                        }
                                    }
                                },
                                type: "WALLET",
                                subType: "VENMO"
                            }
                        };
                    }
                    const currentTip = tipAmountRef.current ?? tipAmount ?? 0;
                    const chargePayload = {
                        ...data,
                        tip: currentTip,
                        tipAmount: currentTip,
                    };
                    const encriptedData = encryptData(JSON.stringify(chargePayload), values.public_key, keys.privateKey, values.key_id);
                    const payload = {
                        publicKey: keys?.publicKey,
                        keyId: encriptedData?.keyId,
                        iv: encriptedData?.iv,
                        data: encriptedData?.encryptedData,
                    };
                    if (encriptedData?.keyId) {
                        const value = await addInventoryOrderChargeById(inventoryorderId, payload);
                        commonRecaptchaToken.current = null;
                        const psGid = value?.paymentSessionGid || value?.paymentSession?.gid;
                        const psSecret = value?.psClientSecret || value?.paymentSession?.psClientSecret;
                        if (psGid) {
                            setOrderData(value);
                            orderDatasRef.current = value;
                            const orderData = await getWalletOrderInfo(psGid, psSecret);
                            if (!orderData.id) {
                                const errorDetail = orderData.details?.[0];
                                const errorMessage = errorDetail
                                    ? `${errorDetail.issue} ${errorDetail.description} (${orderData.debug_id})`
                                    : "Unexpected error occurred, please try again.";
                                throw new Error(errorMessage);
                            }
                            return orderData?.id;
                        }
                    }
                }
            }
        } catch (error) {
            if (error?.status === 429) {
                setSavedPaymentDetails(paypalData);
                setRecaptchaPaymentType('payPalButton');
                setRecaptchaModalVisible(true);
                setTransactionModalOpen(false);
                throw new Error('Recaptcha Required');
            }
            console.error(error);
            throw error || new Error('Unexpected error occurred, please try again.');
        }
    };

    const chargeByIdSuccessActions = async (value) => {
        let nextActionUrl;
        let redirectUrl;
        let returnUrl;
        if (value && value.paymentSession) {
            nextActionUrl = value.paymentSession && value.paymentSession.nextActionUrl ? value.paymentSession.nextActionUrl : value.nextActionUrl;
            redirectUrl = value.paymentSession && value.paymentSession.redirectUrl ? value.paymentSession.redirectUrl : value.redirectUrl;
            returnUrl = value.paymentSession && value.paymentSession.returnUrl;
        } else {
            const info = await getInventoryOrderById(inventoryorderId, null);
            nextActionUrl = info && info.paymentSession && info.paymentSession.nextActionUrl;
            redirectUrl = value && value.redirectUrl;
        }
        if (nextActionUrl) {
            window.location = nextActionUrl;
            return;
        }
        setTransactionModalOpen(false);
        setTransactionSuccessModalOpen(true);
        setTimeout(function () {
            const redirectUri = returnUrl ? returnUrl : redirectUrl ? redirectUrl : SWIREPAY_URL;
            window.location = redirectUri;
            sessionStorage.removeItem("stripeRes");
        }, 10000);
        if (inventoryorderId) {
            localStorage.removeItem(`${inventoryorderId}-tap-index`);
        }
    };

    const chargeByIdFailActions = async () => {
        setTransactionModalOpen(false);
    };

    const addCheckoutPageById = async (data, recaptchaToken = null) => {
        setTransactionModalOpen(true);
        try {
            const values = await getServerEncription(recaptchaToken);
            if (values?.public_key) {
                const keys = generateClientKeyPair();
                if (keys?.privateKey) {
                    const currentTip = data?.tip ?? data?.tipAmount ?? tipAmountRef.current ?? tipAmount ?? 0;
                    const chargePayload = {
                        ...data,
                        tip: currentTip,
                        tipAmount: currentTip,
                    };
                    const encriptedData = encryptData(JSON.stringify(chargePayload), values.public_key, keys.privateKey, values.key_id);
                    const payload = {
                        publicKey: keys?.publicKey,
                        keyId: encriptedData?.keyId,
                        iv: encriptedData?.iv,
                        data: encriptedData?.encryptedData,
                    };
                    if (encriptedData?.keyId) {
                        const value = await addInventoryOrderChargeById(inventoryorderId, payload);
                        if (value) {
                            if (!isPayPalApple.current && !isPayPalGoogle.current) {
                                await chargeByIdSuccessActions(value);
                            }
                            return value;
                        }
                    }
                }
            }
        } catch (reason) {
            if (reason?.status === 429){
                setSavedPaymentDetails(data);
                setRecaptchaModalVisible(true);
                setTransactionModalOpen(false);
                return;
            }
            error(reason);
        }
    };

    const onGlobalCaptchaVerified = async (token) => {
        setRecaptchaModalVisible(false);
        switch (recaptchaPaymentType) {
            case TabNames.UPI:
            case TabNames.INSTANT_PAYMENT:
                setPaymentLinkGlobalRecaptcha(token);
                break;
            case 'paypalApplePay':
                setPaypalApplePayRecaptcha(token);
                setPaypalApplePayMessageModal(true);
                break;
            case 'paypalGooglePay':
                if (paypalPaymentData.current) {
                    chargeByPaypalGooglePay(paypalPaymentData.current, token);
                }
                break;
            case 'cardPointGooglePay':
                setCardPointGooglePayToken(token);
                break;
            case 'payPalButton':
                commonRecaptchaToken.current = token;
                break;
            default:
                await addCheckoutPageById(savedPaymentDetails, token);
        }
        setRecaptchaPaymentType(null);
    };

    const getCheckoutById = async (paymentSession, psClientSecret, redirectionUri) => {
        try {
            const value = await getCheckoutReconnection(paymentSession, psClientSecret);
            if (value) {
                const {status} = value;
                const timeOut = redirectionUri ? SESSION_TIME.REDIRECT_URL : SESSION_TIME.NO_REDIRECT_URL;
                if (status === QR_STATUSES.SUCCEEDED) {
                    if (!redirectionUri) {
                        setTransactionSuccessModalOpen(true);
                    }
                    setTimeout(function () {
                        const redirectUrl = redirectionUri ? redirectionUri : SWIREPAY_URL;
                        const urlPath = redirectUrl.includes("?");
                        if (urlPath) {
                            window.location = `${redirectUrl}&sp-checkout-page=${inventoryorderId}`;
                        } else if (!urlPath) {
                            window.location = `${redirectUrl}?sp-checkout-page=${inventoryorderId}`;
                        }
                    }, timeOut);
                    if (inventoryorderId) {
                        localStorage.removeItem(`${inventoryorderId}-tap-index`)
                    }
                }
            }
        } catch (reason) {
            error(reason);
        }
    };

    const getQrPaymentById = async (paymentSession, psClientSecret, redirectionUri) => {
        try {
            const value = await getQrPaymentReconnection(paymentSession, psClientSecret);
            if (value) {
                const {status} = value;
                const timeOut = redirectionUri ? SESSION_TIME.REDIRECT_URL : SESSION_TIME.NO_REDIRECT_URL;
                if (status === QR_STATUSES.SUCCEEDED) {
                    if (!redirectionUri) {
                        setTransactionSuccessModalOpen(true);
                    }
                    setTimeout(function () {
                        const redirectUrl = redirectionUri ? redirectionUri : SWIREPAY_URL;
                        const urlPath = redirectUrl.includes("?");
                        if (urlPath) {
                            window.location = `${redirectUrl}&sp-checkout-page=${inventoryorderId}`;
                        } else if (!urlPath) {
                            window.location = `${redirectUrl}?sp-checkout-page=${inventoryorderId}`;
                        }
                    }, timeOut);
                    if (inventoryorderId) {
                        localStorage.removeItem(`${inventoryorderId}-tap-index`)
                    }
                }
            }
        } catch (reason) {
            error(reason);
        }
    };

    const cancelAlertOpen = () => {
        setAlertConfig({
            showIcon: true,
            isOpen: true,
            hideBtn: false,
            cancel: resetAlertConfig,
            header: "Are you sure!",
            body: "You will not be able to recover this payment link",
            submitBtnText: "Yes, decline it!",
            cancelBtnText: "Cancel",
            showCancelBtn: true,
            showSubmitBtn: true,
            submit: declinePaymentLink,
            icon: WARNING_ICON
        });
    };

    const resetAlertConfig = () => {
        setAlertConfig(defaultAlertConfig)
    };

    const declinePaymentLink = () => {
        setAlertConfig({
            ...defaultAlertConfig,
            showIcon: true,
            isOpen: true,
            hideBtn: true,
            header: `Please Wait!. Your payment link decline is being processed`,
            body: "You will be redirected when the decline is successful.",
        });
        if (payment && payment.gid) {
            declinePaymentLinkByGid(payment.gid).then(value => {
                if (value) {
                    const {redirectUri} = value;
                    const timeOut = redirectUri ? SESSION_TIME.REDIRECT_URL : SESSION_TIME.NO_REDIRECT_URL;
                    setAlertConfig({
                        ...defaultAlertConfig,
                        showIcon: true, isOpen: true, hideBtn: true,
                        header: "PaymentLink Decline Completed", body: "You will be redirected automatically.",
                        icon: SUCCESS_ICON
                    });
                    setTimeout(function () {
                        const redirectUrl = redirectUri || SWIREPAY_URL;
                        const urlPath = redirectUrl.includes("?");
                        const decline = "decline=true";
                        if (urlPath) {
                            window.location = `${redirectUrl}&${decline}`;
                        } else if (!urlPath) {
                            window.location = `${redirectUrl}?${decline}`;
                        }
                    }, timeOut);
                }
            }).catch(reason => error(reason));
        }
    };

    const shopTips = (payment && payment.tips && payment.tips.filter(t => !t.deleted)) || [];
    const orderSubTotal = orderBreakdown.subTotal || (payment && payment.inventoryOrder && payment.inventoryOrder.subTotal) || 0;
    const currencyPrefix = payment?.account?.currency?.prefix || '$';

    const handleTipPresetClick = (t) => {
        setCustomTip(false);
        setSelectedTipGid(t.gid);
        setTipInputValue('');
        const cents = t.tipType === 'PERCENTAGE'
            ? Math.round((t.tip / 100) * orderSubTotal)
            : Math.round(t.tip * 100);
        tipAmountRef.current = cents;
        handleSplitUpCalculation(cents);
    };

    const handleNoneClick = () => {
        setCustomTip(false);
        setSelectedTipGid(null);
        setTipInputValue('');
        tipAmountRef.current = 0;
        handleSplitUpCalculation(0);
    };

    const tipElement = payment && payment.inventoryOrder ? (
        shopTips.length > 0 ? (
            <div style={{ marginTop: '16px', marginBottom: '8px', width: '100%' }}>
                <div style={{ fontWeight: '600', fontSize: '14px', color: '#1B1B1B', marginBottom: '8px' }}>Add a Tip</div>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '8px', marginTop: '8px' }}>
                    {/* None button */}
                    <button
                        type="button"
                        style={{
                            padding: '10px', background: (!customTip && selectedTipGid === null && tipAmount === 0) ? '#eff6ff' : 'white',
                            border: `1px solid ${(!customTip && selectedTipGid === null && tipAmount === 0) ? '#2563eb' : '#e2e8f0'}`,
                            borderRadius: '8px', fontSize: '13px', fontWeight: '600',
                            color: (!customTip && selectedTipGid === null && tipAmount === 0) ? '#2563eb' : '#475569',
                            cursor: 'pointer', transition: 'all 0.2s',
                        }}
                        onClick={handleNoneClick}
                    >
                        {!customTip && selectedTipGid === null && tipAmount === 0 && <span style={{ marginRight: '4px' }}>✓</span>}
                        None
                    </button>
                    {/* Preset tips from API */}
                    {shopTips.map((t) => {
                        const isActive = !customTip && selectedTipGid === t.gid;
                        return (
                            <button
                                key={t.gid}
                                type="button"
                                style={{
                                    padding: '10px', background: isActive ? '#eff6ff' : 'white',
                                    border: `1px solid ${isActive ? '#2563eb' : '#e2e8f0'}`,
                                    borderRadius: '8px', fontSize: '13px', fontWeight: '600',
                                    color: isActive ? '#2563eb' : '#475569',
                                    cursor: 'pointer', transition: 'all 0.2s',
                                }}
                                onClick={() => handleTipPresetClick(t)}
                            >
                                {isActive && <span style={{ marginRight: '4px' }}>✓</span>}
                                {t.tipType === 'AMOUNT' ? `${currencyPrefix}${parseFloat(t.tip).toFixed(2)}` : `${t.tip}%`}
                            </button>
                        );
                    })}
                    {/* Custom button */}
                    <button
                        type="button"
                        style={{
                            padding: '10px', background: customTip ? '#eff6ff' : 'white',
                            border: `1px solid ${customTip ? '#2563eb' : '#e2e8f0'}`,
                            borderRadius: '8px', fontSize: '13px', fontWeight: '600',
                            color: customTip ? '#2563eb' : '#475569',
                            cursor: 'pointer', transition: 'all 0.2s',
                        }}
                        onClick={() => {
                            setCustomTip(true);
                            setSelectedTipGid(null);
                            setTipInputValue('');
                            handleSplitUpCalculation(0);
                        }}
                    >
                        {customTip && <span style={{ marginRight: '4px' }}>✓</span>}
                        Custom
                    </button>
                </div>
                {customTip && (
                    <TipInput
                        prefix={currencyPrefix}
                        value={tipInputValue}
                        onChange={(val) => setTipInputValue(val)}
                        onApply={handleApplyTip}
                        onRemove={() => { setCustomTip(false); setSelectedTipGid(null); handleClearTip(); }}
                        appliedTip={tipAmount}
                        isLoading={isSplitUpLoading}
                        label={""}
                    />
                )}
            </div>
        ) : (
            <TipInput
                prefix={currencyPrefix}
                value={tipInputValue}
                onChange={(val) => setTipInputValue(val)}
                onApply={handleApplyTip}
                onRemove={handleClearTip}
                appliedTip={tipAmount}
                isLoading={isSplitUpLoading}
            />
        )
    ) : null;

    const googlePaySplitUp = {
        spObjectType: "INVENTORY_ORDER",
        spObjectGid: payment?.inventoryOrder?.gid || inventoryorderId,
        paymentType: "WALLET",
        subType: "GOOGLE_PAY_US",
        binType: "CREDIT"
    };

    const applePaySplitUp = {
        spObjectType: "INVENTORY_ORDER",
        spObjectGid: payment?.inventoryOrder?.gid || inventoryorderId,
        paymentType: "WALLET",
        subType: "APPLE_PAY_US",
        binType: "CREDIT"
    };

    const getCurrentTab = (tab) => {
        setTabName(tab);
    };

    const uniquePaymentTypes = paymentTypeOrder
        ? paymentTypeOrder.map((res) => (res ? res.category : null)).filter(Boolean)
        : supportedPaymentTypes
        ? getUniquePaymentTypes(supportedPaymentTypes)
        : [];

    if (uniquePaymentTypes.includes('WALLET')) {
        if (swirepayUS && !uniquePaymentTypes.includes('SWIREPAY_US')) {
            uniquePaymentTypes.push('SWIREPAY_US');
        }
        if (!googlePayUs) {
            const index = uniquePaymentTypes.indexOf('WALLET');
            if (index > -1) {
                uniquePaymentTypes.splice(index, 1);
            }
        }
        if (uniquePaymentTypes.includes(TabNames.GOOGLE_PAY_US)) {
            const index = uniquePaymentTypes.indexOf(TabNames.GOOGLE_PAY_US);
            if (index > -1) {
                uniquePaymentTypes.splice(index, 1);
            }
        }
    } else if (googlePayUs && !uniquePaymentTypes.includes(TabNames.GOOGLE_PAY_US)) {
        uniquePaymentTypes.push(TabNames.GOOGLE_PAY_US);
    }

    if (uniquePaymentTypes.includes('APPLE_PAY_US')) {
        const index = uniquePaymentTypes.indexOf('APPLE_PAY_US');
        if (index > -1) {
            uniquePaymentTypes.splice(index, 1);
        }
    }

    const currentOrderTotal = orderBreakdown.total || (payment && payment.inventoryOrder && (payment.inventoryOrder.netPayable !== undefined ? payment.inventoryOrder.netPayable : payment.inventoryOrder.total)) || 0;
    const paymentForWallets = payment ? {
        ...payment,
        totalPayable: currentOrderTotal,
        total: currentOrderTotal,
        amount: currentOrderTotal,
        tip: tipAmount,
        tipAmount: tipAmount,
    } : payment;

    const tabPanels = uniquePaymentTypes ? uniquePaymentTypes.reduce(function (panel, name) {
        let children;
        let id;
        if (name === TabNames.ACH_LEGACY) {
            children = <AchPayment
                showCancelBtn={payment && payment.canDecline}
                cancel={cancelAlertOpen}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByAch}
                preFillCustomer={payment && payment.inventoryOrder && payment.inventoryOrder.customer}
                customerDisabled={false}
                headerText={accountGid.includes(payment?.account?.gid) ? "Pay With BANK" : "Pay With ACH"}
                buttonText={submitBtnText}
                customerValidation={true}
                cancelButtonText={"Decline"}
                isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
                // isShippingAddressRequired={(payment && payment.account && payment.account.collectShippingAddress)}
                alpha2={payment && payment.account.currency && payment.account.currency.countryAlpha2}
                plaidPublicToken={plaidPublicToken}
                setPlaidPublicToken={setPlaidPublicToken}
                accountGid={payment?.account?.gid}
                paymentLinkId={inventoryorderId}
                isTest={payment?.account?.portal?.test}
                enableConsentCheckbox={true}
                accountName={payment?.account?.name}
                paymentDate={dayjs().format('MMMM D, YYYY')}
                finalPayAmount={typeof submitBtnText === 'string' && submitBtnText.slice(4)}
                tipComponent={tipElement}
                amount={orderBreakdown.subTotal || (payment && payment.inventoryOrder && payment.inventoryOrder.subTotal) || (payment && payment.inventoryOrder && payment.inventoryOrder.total)}
                discount={orderBreakdown.orderDiscountAmount || (payment && payment.inventoryOrder && payment.inventoryOrder.orderDiscountAmount) || 0}
                tax={orderBreakdown.totalTax || (payment && payment.inventoryOrder && payment.inventoryOrder.totalTax) || 0}
                serviceFeeVal={(orderBreakdown.totalServiceFee || (payment && payment.inventoryOrder && payment.inventoryOrder.totalServiceFee) || 0) + (orderBreakdown.deliveryFee || (payment && payment.inventoryOrder && payment.inventoryOrder.deliveryFee) || 0)}
                tip={tipAmount}
                subTotal={orderBreakdown.subTotal || (payment && payment.inventoryOrder && payment.inventoryOrder.subTotal) || (payment && payment.inventoryOrder && payment.inventoryOrder.total)}
                totalPayable={orderBreakdown.total || (payment && payment.inventoryOrder && payment.inventoryOrder.total)}
            />
            id = name;
        } else if (name === TabNames.CARD) {
            children = <CardPayment
                showCancelBtn={payment && payment.canDecline}
                cancel={cancelAlertOpen}
                hideCustomer={false}
                // showBillDetails={true}
                errorMsg={errorMessage}
                upiError={upiError}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByCard}
                preFillCustomer={payment && payment.inventoryOrder && payment.inventoryOrder.customer}
                headerText={"Pay With Card"}
                cancelButtonText={"Decline"}
                buttonText={submitBtnText}
                isZipCodeRequired={(payment && payment.account && payment.account.collectCustomerAddress)}
                customerValidation={true}
                // charges={true}
                // convenience={convenience}
                // gst={gst}
                prefix={payment && payment.account.currency && payment.account.currency.prefix}
                billAmountApple={AmountDivideByHundred(currentOrderTotal)}
                billAmount={`${currencyFormatter(AmountDivideByHundred(orderBreakdown.total || (payment && payment.inventoryOrder && payment.inventoryOrder.total)), payment && payment.account.currency && payment.account.currency.name)}`}
                alpha2={payment && payment.account.currency && payment.account.currency.countryAlpha2}
                getPaymentCharges={getPaymentCharges}
                totalAmount={totalAmount}
                userType={userType}
                payments={payment && payment}
                ApplePayment={applePayment}
                payment={payment}
                isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
                isShippingAddressRequired={(payment && payment.account && payment.account.collectShippingAddress)}
                chargeByApplePay={chargeByApplePay}
                chargeByApple={chargeByApple}
                showWhatsAppNotify={true}
                tipComponent={tipElement}
                amount={orderBreakdown.subTotal || (payment && payment.inventoryOrder && payment.inventoryOrder.subTotal) || (payment && payment.inventoryOrder && payment.inventoryOrder.total)}
                discount={orderBreakdown.orderDiscountAmount || (payment && payment.inventoryOrder && payment.inventoryOrder.orderDiscountAmount) || 0}
                tax={orderBreakdown.totalTax || (payment && payment.inventoryOrder && payment.inventoryOrder.totalTax) || 0}
                serviceFeeVal={(orderBreakdown.totalServiceFee || (payment && payment.inventoryOrder && payment.inventoryOrder.totalServiceFee) || 0) + (orderBreakdown.deliveryFee || (payment && payment.inventoryOrder && payment.inventoryOrder.deliveryFee) || 0)}
                tip={tipAmount}
                subTotal={orderBreakdown.subTotal || (payment && payment.inventoryOrder && payment.inventoryOrder.subTotal) || (payment && payment.inventoryOrder && payment.inventoryOrder.total)}
                totalPayable={orderBreakdown.total || (payment && payment.inventoryOrder && payment.inventoryOrder.total)}
            />
            id = name;
        } else if (name === TabNames.NET_BANKING) {
            children = <NetBanking
                showCancelBtn={payment && payment.canDecline}
                cancel={cancelAlertOpen}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByNetBanking}
                preFillCustomer={payment && payment.inventoryOrder && payment.inventoryOrder.customer}
                headerText={"PAY WITH NET BANKING"}
                cancelButtonText={"Decline"}
                buttonText={submitBtnText}
                customerValidation={true}
                banksList={banksList}
                bankTypes={bankTypes}
                isTest={isTest}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
            />
            id = name;
        } else if (name === TabNames.GOOGLE_PAY_US || name === TabNames.WALLET) {
            children = <>
                {
                    payPalClientAuth ? (
                        <PayPalGooglePay
                            headerText={"PAY WITH GOOGLE PAY"}
                            payment={paymentForWallets}
                            chargeByGooglePay={chargeByPaypalGooglePay}
                            gpayError={gpayError}
                            errorMsg={errorMessage}
                            errorHeader={null}
                            accountGid={payment?.account?.gid}
                            setTransactionModalOpen={setTransactionModalOpen}
                            splitUpPayload={googlePaySplitUp}
                            tipComponent={tipElement}
                        />
                    ) : (
                        <GooglePay
                            headerText={"PAY WITH GOOGLE PAY"}
                            preFillCustomer={payment && payment.inventoryOrder && payment.inventoryOrder.customer}
                            chargeByGooglePay={chargeByGooglePay}
                            payment={paymentForWallets}
                            gpaySecretValues={gpaySecretValues}
                            gpayError={gpayError}
                            errorMsg={errorMessage}
                            errorHeader={null}
                            splitUpPayload={googlePaySplitUp}
                            tipComponent={tipElement}
                        />
                    )
                }
            </>;
            id = name;
        } else if (name === TabNames.INSTANT_PAYMENT) {
            children = <InstantPayment
                showCancelBtn={payment && payment.canDecline}
                headerText={"PAY WITH WALLET Alias"}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByInstantPay}
                hideQr={false}
                getPaymentById={getQrPaymentById}
                upiUrl={`${BASE_URLS.INVENTORY_ORDER_CHARAGE}/${inventoryorderId}`}
                buttonText={submitBtnText}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                prefix={payment && payment.account && payment.account.currency && payment.account.currency.prefix}
                setRecaptchaModalVisible={setRecaptchaModalVisible}
                setSavedPaymentDetails={setSavedPaymentDetails}
                savedPaymentDetails={savedPaymentDetails}
                globalRecaptchaToken={paymentLinkGlobalRecaptcha}
                setGlobalRecaptchaToken={setPaymentLinkGlobalRecaptcha}
                setRecaptchaPaymentType={setRecaptchaPaymentType}
                tipComponent={tipElement}
                amount={orderBreakdown.subTotal || (payment && payment.inventoryOrder && payment.inventoryOrder.subTotal) || (payment && payment.inventoryOrder && payment.inventoryOrder.total)}
                discount={orderBreakdown.orderDiscountAmount || (payment && payment.inventoryOrder && payment.inventoryOrder.orderDiscountAmount) || 0}
                tax={orderBreakdown.totalTax || (payment && payment.inventoryOrder && payment.inventoryOrder.totalTax) || 0}
                serviceFeeVal={(orderBreakdown.totalServiceFee || (payment && payment.inventoryOrder && payment.inventoryOrder.totalServiceFee) || 0) + (orderBreakdown.deliveryFee || (payment && payment.inventoryOrder && payment.inventoryOrder.deliveryFee) || 0)}
                tip={tipAmount}
                subTotal={orderBreakdown.subTotal || (payment && payment.inventoryOrder && payment.inventoryOrder.subTotal) || (payment && payment.inventoryOrder && payment.inventoryOrder.total)}
                totalPayable={orderBreakdown.total || (payment && payment.inventoryOrder && payment.inventoryOrder.total)}
            />
            id = name;
        } else if (name === TabNames.SWIREPAY_US) {
            children = <InstantPayment
                showCancelBtn={payment && payment.canDecline}
                headerText={"PAY WITH WALLET Alias"}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeBySwirepayUS}
                hideQr={false}
                getPaymentById={getQrPaymentById}
                upiUrl={`${BASE_URLS.INVENTORY_ORDER_CHARAGE}/${inventoryorderId}`}
                buttonText={submitBtnText}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                prefix={payment && payment.account && payment.account.currency && payment.account.currency.prefix}
                swirepayUS={swirepayUS}
                setRecaptchaModalVisible={setRecaptchaModalVisible}
                setSavedPaymentDetails={setSavedPaymentDetails}
                savedPaymentDetails={savedPaymentDetails}
                globalRecaptchaToken={paymentLinkGlobalRecaptcha}
                setGlobalRecaptchaToken={setPaymentLinkGlobalRecaptcha}
                setRecaptchaPaymentType={setRecaptchaPaymentType}
                tipComponent={tipElement}
                amount={orderBreakdown.subTotal || (payment && payment.inventoryOrder && payment.inventoryOrder.subTotal) || (payment && payment.inventoryOrder && payment.inventoryOrder.total)}
                discount={orderBreakdown.orderDiscountAmount || (payment && payment.inventoryOrder && payment.inventoryOrder.orderDiscountAmount) || 0}
                tax={orderBreakdown.totalTax || (payment && payment.inventoryOrder && payment.inventoryOrder.totalTax) || 0}
                serviceFeeVal={(orderBreakdown.totalServiceFee || (payment && payment.inventoryOrder && payment.inventoryOrder.totalServiceFee) || 0) + (orderBreakdown.deliveryFee || (payment && payment.inventoryOrder && payment.inventoryOrder.deliveryFee) || 0)}
                tip={tipAmount}
                subTotal={orderBreakdown.subTotal || (payment && payment.inventoryOrder && payment.inventoryOrder.subTotal) || (payment && payment.inventoryOrder && payment.inventoryOrder.total)}
                totalPayable={orderBreakdown.total || (payment && payment.inventoryOrder && payment.inventoryOrder.total)}
            />
            id = name;
        } else {
            children = <DescriptionText>Processing payment. Please wait...</DescriptionText>
        }
        panel.push({children, id});
        return panel;
    }, []) : [
        {
            children: <CardPayment
                showCancelBtn={payment && payment.canDecline}
                cancel={cancelAlertOpen}
                hideCustomer={false}
                // showBillDetails={true}
                errorMsg={errorMessage}
                upiError={upiError}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByCard}
                preFillCustomer={payment && payment.inventoryOrder && payment.inventoryOrder.customer}
                headerText={"Pay With Card"}
                cancelButtonText={"Decline"}
                buttonText={submitBtnText}
                isZipCodeRequired={(payment && payment.account && payment.account.collectCustomerAddress)}
                customerValidation={true}
                // charges={true}
                // convenience={convenience}
                // gst={gst}
                prefix={payment && payment.account.currency && payment.account.currency.prefix}
                billAmountApple={AmountDivideByHundred(currentOrderTotal)}
                billAmount={`${currencyFormatter(AmountDivideByHundred(orderBreakdown.total || (payment && payment.inventoryOrder && payment.inventoryOrder.total)), payment && payment.account.currency && payment.account.currency.name)}`}
                alpha2={payment && payment.account.currency && payment.account.currency.countryAlpha2}
                getPaymentCharges={getPaymentCharges}
                totalAmount={totalAmount}
                userType={userType}
                payments={payment && payment}
                ApplePayment={applePayment}
                payment={payment}
                isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
                isShippingAddressRequired={(payment && payment.account && payment.account.collectShippingAddress)}
                chargeByApplePay={chargeByApplePay}
                chargeByApple={chargeByApple}
                showWhatsAppNotify={true}
                tipComponent={tipElement}
                amount={orderBreakdown.subTotal || (payment && payment.inventoryOrder && payment.inventoryOrder.subTotal) || (payment && payment.inventoryOrder && payment.inventoryOrder.total)}
                discount={orderBreakdown.orderDiscountAmount || (payment && payment.inventoryOrder && payment.inventoryOrder.orderDiscountAmount) || 0}
                tax={orderBreakdown.totalTax || (payment && payment.inventoryOrder && payment.inventoryOrder.totalTax) || 0}
                serviceFeeVal={(orderBreakdown.totalServiceFee || (payment && payment.inventoryOrder && payment.inventoryOrder.totalServiceFee) || 0) + (orderBreakdown.deliveryFee || (payment && payment.inventoryOrder && payment.inventoryOrder.deliveryFee) || 0)}
                tip={tipAmount}
                subTotal={orderBreakdown.subTotal || (payment && payment.inventoryOrder && payment.inventoryOrder.subTotal) || (payment && payment.inventoryOrder && payment.inventoryOrder.total)}
                totalPayable={orderBreakdown.total || (payment && payment.inventoryOrder && payment.inventoryOrder.total)}
            />,
            id: 'CARD'
        }
    ]

    const tabPanelsApple = {
        children: <>
            {
                payPalClientAuth ? (
                    <ApplePayButton
                        recaptchaToken={paypalApplePayRecaptcha}
                        amount={currentOrderTotal}
                        chargeByApple={chargeByApple}
                        payment={paymentForWallets}
                        accountGid={payment?.account?.gid}
                        successCallback={chargeByIdSuccessActions}
                        failCallback={chargeByIdFailActions}
                        splitUpPayload={applePaySplitUp}
                        tipComponent={tipElement}
                    />
                ) : (
                    <>
                        {
                            applePayment && isApplePay ? (
                                <Apple
                                    amount={currentOrderTotal}
                                    chargeByApple={chargeByCardpointeApplePay}
                                    payment={paymentForWallets}
                                    tipComponent={tipElement}
                                    splitUpPayload={applePaySplitUp}
                                />
                            ) : null
                        }
                    </>
                )
            }
        </>,
        id: applePayment && isApplePay ? 'APPLE_PAY_US' : null
    };
    tabPanels.push(tabPanelsApple);

    if (payment?.account?.country?.alpha2 === 'US') {
      tabPanels.push({
          children: <SavedPaymentMethods
                      buttonText={`${currencyFormatter(AmountDivideByHundred(orderBreakdown.total || (payment && payment.inventoryOrder && payment.inventoryOrder.total)), payment && payment.account.currency && payment.account.currency.name)}` || submitBtnText}
                      submit={chargeBySavedPaymentMethods}
                      supportedPaymentTypes={uniquePaymentTypes}
                      accountSupportedPaymentTypes={payment?.account?.supportedPaymentTypes}
                      prefix={payment && payment.account && payment.account.currency && payment.account.currency.prefix}
                      tipComponent={tipElement}
                      amount={orderBreakdown.subTotal || (payment && payment.inventoryOrder && payment.inventoryOrder.subTotal) || (payment && payment.inventoryOrder && payment.inventoryOrder.total)}
                      discount={orderBreakdown.orderDiscountAmount || (payment && payment.inventoryOrder && payment.inventoryOrder.orderDiscountAmount) || 0}
                      tax={orderBreakdown.totalTax || (payment && payment.inventoryOrder && payment.inventoryOrder.totalTax) || 0}
                      serviceFeeVal={(orderBreakdown.totalServiceFee || (payment && payment.inventoryOrder && payment.inventoryOrder.totalServiceFee) || 0) + (orderBreakdown.deliveryFee || (payment && payment.inventoryOrder && payment.inventoryOrder.deliveryFee) || 0)}
                      tip={tipAmount}
                      subTotal={orderBreakdown.subTotal || (payment && payment.inventoryOrder && payment.inventoryOrder.subTotal) || (payment && payment.inventoryOrder && payment.inventoryOrder.total)}
                      totalPayable={orderBreakdown.total || (payment && payment.inventoryOrder && payment.inventoryOrder.total)}
                  />,
          id: 'SAVED_PAYMENT_METHODS'
      });
    }

    if (payPalClientAuth
        && payPalClientId
        && !tabPanels.map(item => item.id).includes('PAYPAL_METHOD')
        && (payment?.account?.supportedPaymentTypes?.includes('PAYPAL_WALLET') || payment?.account?.supportedPaymentTypes?.includes('VENMO'))
        && PayPalCheckoutEnable.current
    ) {
      tabPanels.push({
        children: <div>
          <PayPalCheckout
            styles={{ shape: "rect", layout: "vertical" }}
            createOrder={createOrder}
            onApprove={onApprove}
            payPalClientId={payPalClientId}
            currency={payment?.account?.currency?.name || 'USD'}
            country={payment?.account?.country?.alpha2 || 'US'}
            accountSupportedPaymentTypes={payment?.account?.supportedPaymentTypes}
            tipComponent={tipElement}
          />
        </div>,
        id: 'PAYPAL_METHOD',
      });
      if (!uniquePaymentTypes.includes('PAYPAL_METHOD')) uniquePaymentTypes.push('PAYPAL_METHOD');
    }

    useEffect(() => {
        setTabName(uniquePaymentTypes && uniquePaymentTypes[selectedTab]);
    }, [selectedTab, uniquePaymentTypes]);
    const agregatorName = payment && payment.account && payment.account.aggregatorName;

    return (
        <BaseSplitPage
        errorHeader={null}
        errorMsg={errorMessage}
        left={
            <>
                <FlexContainer
                    flexDirection="column"
                    position="relative"
                    display="block"
                    height="100%"
                >
                    <div>
                        {
                            (payment && payment.account && payment.account.largeLogo) && (
                                <img src={payment.account.largeLogo} style={{width: "125px"}} alt=""/>
                            )
                        }
                        <H1Text>
                            Payment Checkout
                        </H1Text>
                        <div className="mb-2" style={{fontWeight: '400', fontSize: '14px', color: '#909090'}}>
                            Payment For
                        </div>
                        <Row>
                            <Col className="mt-2"
                                 style={{fontWeight: '600', fontSize: '18px', marginLeft: "0px", color: '#1B1B1B'}}>
                                {(payment && payment.description) || (payment && payment.account && payment.account.name && payment.account.name === 'Shastha Fresh Delivery Store' ? 'Shastha Fresh' : (payment && payment.account && payment.account.name))}
                            </Col>
                        </Row>
                        <div className="mt-3 mb-3" style={{fontWeight: '400', fontSize: '13px', color: '#474747'}}>
                            <p>
                                Reference Id: {
                                (payment && payment.gid) ? (payment.gid).slice(-REFRENCE_ID_LENGTH) : <>&#8211;</>
                            }
                            </p>
                        </div>
                        {
                            tabName === 'UPI' && (
                                <>
                                    <H2Text>
                                        Amount
                                    </H2Text>
                                    <DescriptionText fontSize="24px">
                                        {payment ? `${currencyFormatter(AmountDivideByHundred(orderBreakdown.total || (payment.inventoryOrder && (payment.inventoryOrder.netPayable !== undefined ? payment.inventoryOrder.netPayable : payment.inventoryOrder.total)) || 0), payment.account.currency && payment.account.currency.name)}` : null}
                                    </DescriptionText>
                                </>
                            )
                        }

                    </div>
                    <div style={{position: "sticky", top: "85%"}}>
                        <Support email={payment && payment.support && payment.support.email}
                                 phone={payment && payment.support && (payment.account.gid === 'account-25729ddf59914c9abcb41a107d824330' ? '+16507435681' : payment.support.phone)}
                                 whiteLabel={payment && payment.account && payment.account.whiteLabel}
                                 partnerImageUrl={partnerImageUrl}
                                 bankImageUrl={bankImageUrl}/>
                        {agregatorName === 'EPAYMENTS' ?
                            <div style={{position: "sticky", marginLeft: "75%", bottom: "9%"}}>
                                <a href="https://www.swirepay.com" target="_blank">
                                    <img src={EPaymentImg} alt=""/>
                                </a>
                            </div>
                            :
                            agregatorName === 'OMEGAITR' ?
                                <div style={{position: "sticky", marginLeft: "75%", bottom: "9%"}}>
                                    <a href="https://www.swirepay.com" target="_blank">
                                        <img src={OMEGAITRlogo} alt=""/>
                                    </a>
                                </div>
                                :
                                ''
                        }

                    </div>
                </FlexContainer>
            </>
        } right={
            <>
                <Header 
                    payment={payment} 
                    bankImageUrl={bankImageUrl} 
                    tabName={tabName}
                    cancelUrlLink={null}
                    totalAmount={totalAmount}
                />
                {payment?.account?.country?.alpha2 === 'US' ? (
                  <PaymentExpandableRowsV2
                    name={inventoryorderId}
                    id={inventoryorderId}
                    paymentTypes={(payment && payment.account && payment.account.currency && payment.account.currency.countryAlpha2)}
                    tabs={uniquePaymentTypes}
                    tabPanels={tabPanels}
                    defaultSelectedTab={selectedTab || 0}
                    onSelect={data => setSelectedTab(data)}
                    tabName={tabName}
                    upiDown={upiDownTime}
                    applePayment={applePayment}
                    isApplePay ={isApplePay}
                    accountGid={payment?.account?.gid}
                    supportedPaymentTypes={payment?.account?.supportedPaymentTypes}
                    account={payment?.account}
                    getCurrentTab={getCurrentTab}
                  />) : (
                  <PaymentExpandableRows
                    name={inventoryorderId}
                    id={inventoryorderId}
                    paymentTypes={(payment && payment.account && payment.account.currency && payment.account.currency.countryAlpha2)}
                    tabs={uniquePaymentTypes}
                    tabPanels={tabPanels}
                    defaultSelectedTab={selectedTab || 0}
                    onSelect={data => setSelectedTab(data)}
                    tabName={tabName}
                    upiDown={upiDownTime}
                    applePayment={applePayment}
                    isApplePay={isApplePay}
                    accountGid={payment?.account?.gid}
                    getCurrentTab={getCurrentTab}
                  />
                )}
                <SmallScreenFooter
                    partnerImageUrl={partnerImageUrl}
                    bankImageUrl={bankImageUrl}
                    whiteLabel={payment && payment.account && payment.account.whiteLabel}
                />
                <RecaptchaModal
                    visible={recaptchaModalVisible}
                    onVerified={onGlobalCaptchaVerified}
                />
                <TransactionModal body={null} header={null} isOpen={isTransactionModalOpen}/>
                <SuccessModal isOpen={isTransactionSuccessModalOpen}/>
                <AlertModal
                    showIcon={alertConfig.showIcon}
                    isOpen={alertConfig.isOpen}
                    hideBtn={alertConfig.hideBtn}
                    cancel={alertConfig.cancel}
                    header={alertConfig.header}
                    body={alertConfig.body}
                    submitBtnText={alertConfig.submitBtnText}
                    cancelBtnText={alertConfig.cancelBtnText}
                    showCancelBtn={alertConfig.showCancelBtn}
                    showSubmitBtn={alertConfig.showSubmitBtn} submit={alertConfig.submit} icon={alertConfig.icon}/>
                <AlertModal
                    isOpen={paypalApplePayMessageModal}
                    header="User Action Required"
                    showSubmitBtn={true}
                    submitBtnText="Ok"
                    submit={() => setPaypalApplePayMessageModal(false)}
                    body="Please click on Apple Pay again to pay through it."
                    icon={WARNING_ICON}
                    showIcon={true}
                />
                <Spinner isOpen={isShowSpinner}/>
            </>
        }/>
    )
};

export default InventoryOrder;
